/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Sdh_DescriptionInputs */

const en_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select the SDH elements you want to remove from the captions`)
};

const fr_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez les éléments SDH à supprimer des sous-titres`)
};

const de_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie die SDH-Elemente aus, die Sie aus den Untertiteln entfernen möchten.`)
};

const it_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona gli elementi SDH che vuoi rimuovere dalle didascalie`)
};

const ru_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите элементы SDH, которые вы хотите удалить из подписей.`)
};

const es_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione los elementos SDH que desea eliminar de los subtítulos`)
};

const zh_cn2_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择要从字幕中移除的 SDH 元素`)
};

const ja_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャプションから削除したいSDH要素を選択します`)
};

const hi_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उन एसडीएच तत्वों का चयन करें जिन्हें आप कैप्शन से हटाना चाहते हैं।`)
};

const pt_pt2_remove_sdh_description = /** @type {(inputs: Remove_Sdh_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione os elementos SDH que deseja remover das legendas.`)
};

/**
* | output |
* | --- |
* | "Select the SDH elements you want to remove from the captions" |
*
* @param {Remove_Sdh_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_sdh_description = /** @type {((inputs?: Remove_Sdh_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Sdh_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_remove_sdh_description(inputs)
	if (locale === "de") return de_remove_sdh_description(inputs)
	if (locale === "it") return it_remove_sdh_description(inputs)
	if (locale === "ru") return ru_remove_sdh_description(inputs)
	if (locale === "es") return es_remove_sdh_description(inputs)
	if (locale === "zh-CN") return zh_cn2_remove_sdh_description(inputs)
	if (locale === "ja") return ja_remove_sdh_description(inputs)
	if (locale === "hi") return hi_remove_sdh_description(inputs)
	if (locale === "pt-PT") return pt_pt2_remove_sdh_description(inputs)
	return en_remove_sdh_description(inputs)
});